import React from 'react'
import { toast } from 'react-toastify'

function successNotification(successMessage) {
  toast.dismiss()
  return (

    toast(
      
      successMessage, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "success",
    })
  )
}

export default successNotification